export default {
  name: 'Switch',
  displayName: {
    en: 'Switch',
    ja: 'スイッチ',
  },
  icon: './example-thumbnail.png',
  defaultWidth: 40,
  defaultHeight: 20,
  props: [
    // {
    //   name: 'toggle',
    //   displayName: 'What does this switch change?',
    //   type: 'boolean',
    //   role: 'autosaveInput',
    // },
    {
      name: 'color',
      displayName: {
        en: 'Color',
        ja: '色',
      },
      type: 'color',
      default: '@primary',
    },
    {
      name: 'value',
      displayName: {
        en: 'Default Value',
        ja: '初期値',
      },
      type: 'boolean',
      role: 'autosaveInput',
    },
    // {
    //   name: 'value',
    //   displayName: {
    //     en: 'Default Value',
    //     ja: '初期値',
    //   },
    //   type: 'text',
    //   control: {
    //     type: 'menu',
    //     options: [
    //       {
    //         label: 'canvas.menuRight.elementTab.switch.true',
    //         value: true,
    //       },
    //       {
    //         label: 'canvas.menuRight.elementTab.switch.false',
    //         value: false,
    //       },
    //     ],
    //   },
    // },
    {
      name: 'onActions',
      displayName: {
        en: 'Actions when Switch is turned ON',
        ja: 'スイッチONのアクション',
      },
      type: 'action',
    },
    {
      name: 'offActions',
      displayName: {
        en: 'Actions when Switch is turned OFF',
        ja: 'スイッチOFFのアクション',
      },
      type: 'action',
    },
    {
      name: 'switchValue',
      displayName: 'Value',
      role: 'formValue',
      type: 'boolean',
    },
  ],
  resizeX: false,
  attributes: {
    trackColorOn: {
      displayName: {
        en: 'Bar color (on)',
        ja: 'バーの色 オン',
      },
    },
    thumbColorOn: {
      displayName: {
        en: 'Thumb color (on)',
        ja: '円の色 オン',
      },
    },
    trackColorOff: {
      displayName: {
        en: 'Bar color (off)',
        ja: 'バーの色 オフ',
      },
    },
    thumbColorOff: {
      displayName: {
        en: 'Thumb color (off)',
        ja: '円の色 オフ',
      },
    },
  },
};
